export const EQUIPMENT_STATUS_OPTIONS = [
  { id: "UNSPECIFIED", value: "", label: "Unspecified" },
  { id: "IN_SERVICE", value: "inservice", label: "In Service" },
  { id: "RENTED", value: "rented", label: "Rented" },
  { id: "PENDING", value: "pending", label: "Pending" },
  { id: "COMPLETED", value: "completed", label: "Completed" },
  { id: "AVAILABLE", value: "available", label: "Available" },
  { id: "UNAVAILABLE", value: "unavailable", label: "Unavailable" },
  { id: "REPAIR", value: "repair", label: "Repair" },
  { id: "RETIRED", value: "retired", label: "Retired" },
  { id: "SPARE", value: "spare", label: "Spare" },
];

export const ASSET_TYPE_OPTIONS = [
  { id: "UNSPECIFIED", value: "Not Specified", label: "Unspecified" },
  { id: "AMBULANCE", value: "Ambulance", label: "Ambulance" },
  { id: "ARMORED_TRUCK", value: "Armored Truck", label: "Armored Truck" },
  { id: "BOX_TRUCK", value: "Box Truck", label: "Box Truck" },
  { id: "BUCKET_TRUCK", value: "Bucket Truck", label: "Bucket Truck" },
  { id: "CABLE_PULLER", value: "Cable Puller", label: "Cable Puller" },
  { id: "CAR", value: "Car", label: "Car" },
  { id: "CAR_CARRIER", value: "Car Carrier", label: "Car Carrier" },
  { id: "CLIP_TRUCK", value: "Clip Truck", label: "Clip Truck" },
  { id: "CONTAINER", value: "Container", label: "Container" },
  { id: "DUMP_TRUCK", value: "Dump Truck", label: "Dump Truck" },
  {
    id: "ELECTRIC_VEHICLE",
    value: "Electric Vehicle",
    label: "Electric Vehicle",
  },
  { id: "FIRE_ENGINE", value: "Fire Engine", label: "Fire Engine" },
  { id: "FLATBED", value: "Flatbed", label: "Flatbed" },
  { id: "GANG_TRUCK", value: "Gang Truck", label: "Gang Truck" },
  { id: "HEAVY_TRUCK", value: "Heavy Truck", label: "Heavy Truck" },
  { id: "LIGHT_TRUCK", value: "Light Truck", label: "Light Truck" },
  { id: "LINE_TRUCK", value: "Line Truck", label: "Line Truck" },
  { id: "MOBILE_WASH", value: "Mobile Wash", label: "Mobile Wash" },
  {
    id: "PICKUP_WITH_PLOW",
    value: "Pickup with Plow",
    label: "Pickup with Plow",
  },
  { id: "PICK_UP", value: "Pick Up", label: "Pick Up" },
  { id: "RACK_TRUCK", value: "Rack Truck", label: "Rack Truck" },
  { id: "RACK_WITH_BOOM", value: "Rack with Boom", label: "Rack with Boom" },
  { id: "RAILCAR", value: "Railcar", label: "Railcar" },
  { id: "REEFER", value: "Reefer", label: "Reefer" },
  { id: "ROAD_TRUCK", value: "Road Truck", label: "Road Truck" },
  { id: "RODDER_TRUCK", value: "Rodder Truck", label: "Rodder Truck" },
  { id: "ROLL_OFF", value: "Roll Off", label: "Roll Off" },
  { id: "SCISSOR_LIFT", value: "Scissor Lift", label: "Scissor Lift" },
  { id: "SEDAN", value: "Sedan", label: "Sedan" },
  { id: "SEWER_TRUCK", value: "Sewer Truck", label: "Sewer Truck" },
  { id: "SNOW_FIGHTER", value: "Snow Fighter", label: "Snow Fighter" },
  { id: "SNOW_PLOW", value: "Snow Plow", label: "Snow Plow" },
  { id: "STEP_VAN", value: "Step Van", label: "Step Van" },
  { id: "SUV", value: "SUV", label: "SUV" },
  { id: "SUV_WITH_PLOW", value: "SUV with Plow", label: "SUV with Plow" },
  { id: "TANKER", value: "Tanker", label: "Tanker" },
  { id: "TOW_BOAT", value: "Tow Boat", label: "Tow Boat" },
  { id: "TOW_TRUCK", value: "Tow Truck", label: "Tow Truck" },
  { id: "TRAILER", value: "Trailer", label: "Trailer" },
  { id: "TRACTOR", value: "Tractor", label: "Tractor" },
  { id: "TRUCK", value: "Truck", label: "Truck" },
  { id: "UTILITY_TRUCK", value: "Utility Truck", label: "Utility Truck" },
  { id: "VAC_TRUCK", value: "Vac Truck", label: "Vac Truck" },
  { id: "VAN", value: "Van", label: "Van" },
  { id: "VEHICLE", value: "Vehicle", label: "Vehicle" },
  { id: "WELDING_TRUCK", value: "Welding Truck", label: "Welding Truck" },
  { id: "OTHER", value: "Other", label: "Other" },
];

export const VEHICLE_CLASS_OPTIONS = [
  // TODO: This list should be received from a DB table
  { id: "UNSPECIFIED", value: "", label: "Unspecified" },
  { id: "C", value: "C", label: "C" },
  { id: "CDL_A", value: "CDL_A", label: "CDL_A" },
  { id: "CDL_B", value: "CDL_B", label: "CDL_B" },
  { id: "CDL_C", value: "CDL_C", label: "CDL_C" },
  { id: "D", value: "D", label: "D" },
  { id: "D_CONDITIONAL", value: "D_CONDITIONAL", label: "D_CONDITIONAL" },
  { id: "D_RESTRICED", value: "D_RESTRICED", label: "D_RESTRICED" },
  { id: "E", value: "E", label: "E" },
  { id: "G", value: "G", label: "G" },
  { id: "N_A", value: "N/A", label: "N/A" },
  { id: "PERMIT", value: "PERMIT", label: "PERMIT" },
  { id: "T", value: "T", label: "T" },
  { id: "V", value: "V", label: "V" },
];

export const MAP_ROUTE_COLOR_OPTIONS = [
  { id: "DEFAULT", value: "", label: "Default" },
  { id: "BLACK", value: "#000000", label: "Black" },
  { id: "BROWN", value: "#a52a2a", label: "Brown" },
  { id: "RED", value: "#dd0000", label: "Red" },
  { id: "ORANGE", value: "#b37400", label: "Orange" },
  { id: "GREEN", value: "#008f00", label: "Green" },
  { id: "BLUE", value: "#0000ee", label: "Blue" },
  { id: "PURPLE", value: "#9400d3", label: "Purple" },
  { id: "GRAY", value: "#505050", label: "Gray" },
  { id: "CYAN", value: "#00b3b3", label: "Cyan" },
  { id: "PINK", value: "#ff1493", label: "Pink" },
  { id: "NONE", value: "none", label: "None" },
];

export const IGNITION_INPUT_OPTIONS = [
  { id: "N_A", value: "-1", label: "N/A" },
  { id: "START_STOP", value: "200", label: "Start/Stop" },
  { id: "IGNITION_ON_OFF", value: "99", label: "IgnitionOn/Off" }, // defaults to index 2 in the dropdown
  // { id: "ZERO", value: "0", label: "0" },
  // { id: "ONE", value: "1", label: "1" },
  // { id: "TWO", value: "2", label: "2" },
  // { id: "THREE", value: "3", label: "3" },
  // { id: "FOUR", value: "4", label: "4" },
  // { id: "FIVE", value: "5", label: "5" },
  // { id: "SIX", value: "6", label: "6" },
  // { id: "SEVEN", value: "7", label: "7" }
];

export const FUEL_TYPE_OPTIONS = [
  { id: "1100", value: "1100", label: "Unleaded" },
  { id: "4000", value: "4000", label: "Diesel" },
  { id: "1900", value: "1900", label: "Leaded" },
  { id: "2000", value: "2000", label: "Ethenol" },
  { id: "3000", value: "3000", label: "Methenol" },
  { id: "5000", value: "5000", label: "Biodiesel" },
  { id: "6000", value: "6000", label: "Kerosene" },
  { id: "8000", value: "8000", label: "LPG" },
  { id: "8100", value: "8100", label: "Propane" },
  { id: "8200", value: "8200", label: "Butane" },
  { id: "9000", value: "9000", label: "CNG" },
  { id: "9100", value: "9100", label: "Methane" },
  { id: "10000", value: "10000", label: "Hydrogen" },
  { id: "90000", value: "90000", label: "Electric" },
  { id: "99999", value: "99999", label: "Other" },
  { id: "0", value: "0", label: "Unknown" },
];

export const RECORDER_ON_OPTIONS = [
  { id: "UNKNOWN", value: "", label: "Unknown" },
  { id: "YES", value: "1", label: "Yes" },
  { id: "NO", value: "0", label: "No" },
];

export enum CAMERA_TYPES {
  NONE = 0,
  SURFSIGHT = 2,
  VISIONMAX = 3,
}

// deprecated, using RECORDER_TYPE_OPTION_1 and RECORDER_TYPE_OPTION_2 instead
// export const RECORDER_TYPE_OPTIONS = [
//   { id: "NONE", value: "0", label: "None" },
//   // { id: "SMARTWITNESS", value: "1", label: "SmartWitness" },
//   { id: "SURFSIGHT", value: "2", label: "Surfsight" },
// ];

export const RECORDER_TYPE_OPTIONS_SURFSIGHT = [
  { id: "NONE", value: CAMERA_TYPES.NONE.toString(), label: "None" },
  {
    id: "SURFSIGHT",
    value: CAMERA_TYPES.SURFSIGHT.toString(),
    label: "Surfsight",
  },
];

export const RECORDER_TYPE_OPTIONS_VISIONMAX = [
  { id: "NONE", value: CAMERA_TYPES.NONE.toString(), label: "None" },
  {
    id: "VISIONMAX",
    value: CAMERA_TYPES.VISIONMAX.toString(),
    label: "FleetVision",
  }, // VisionMax is called FleetVision in the UI
];
